/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTranscriptionSummarization200Response } from '../models';
/**
 * TranscriptionSummarizationApi - axios parameter creator
 * @export
 */
export const TranscriptionSummarizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 文字起こし要約取得API
         * @summary 文字起こし要約取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionSummarization: async (zoomPhoneResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoomPhoneResultId' is not null or undefined
            assertParamExists('getTranscriptionSummarization', 'zoomPhoneResultId', zoomPhoneResultId)
            const localVarPath = `/api/user/zoom_phone_results/{zoomPhoneResultId}/transcription/summarization`
                .replace(`{${"zoomPhoneResultId"}}`, encodeURIComponent(String(zoomPhoneResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 文字起こし要約生成API
         * @summary 文字起こし要約生成API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranscriptionSummarize: async (zoomPhoneResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoomPhoneResultId' is not null or undefined
            assertParamExists('postTranscriptionSummarize', 'zoomPhoneResultId', zoomPhoneResultId)
            const localVarPath = `/api/user/zoom_phone_results/{zoomPhoneResultId}/transcription/summarize`
                .replace(`{${"zoomPhoneResultId"}}`, encodeURIComponent(String(zoomPhoneResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranscriptionSummarizationApi - functional programming interface
 * @export
 */
export const TranscriptionSummarizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranscriptionSummarizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 文字起こし要約取得API
         * @summary 文字起こし要約取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptionSummarization(zoomPhoneResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranscriptionSummarization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptionSummarization(zoomPhoneResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 文字起こし要約生成API
         * @summary 文字起こし要約生成API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranscriptionSummarize(zoomPhoneResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranscriptionSummarize(zoomPhoneResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TranscriptionSummarizationApi - factory interface
 * @export
 */
export const TranscriptionSummarizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranscriptionSummarizationApiFp(configuration)
    return {
        /**
         * 文字起こし要約取得API
         * @summary 文字起こし要約取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionSummarization(zoomPhoneResultId: number, options?: any): AxiosPromise<GetTranscriptionSummarization200Response> {
            return localVarFp.getTranscriptionSummarization(zoomPhoneResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * 文字起こし要約生成API
         * @summary 文字起こし要約生成API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranscriptionSummarize(zoomPhoneResultId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postTranscriptionSummarize(zoomPhoneResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranscriptionSummarizationApi - interface
 * @export
 * @interface TranscriptionSummarizationApi
 */
export interface TranscriptionSummarizationApiInterface {
    /**
     * 文字起こし要約取得API
     * @summary 文字起こし要約取得API
     * @param {number} zoomPhoneResultId ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionSummarizationApiInterface
     */
    getTranscriptionSummarization(zoomPhoneResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetTranscriptionSummarization200Response>;

    /**
     * 文字起こし要約生成API
     * @summary 文字起こし要約生成API
     * @param {number} zoomPhoneResultId ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionSummarizationApiInterface
     */
    postTranscriptionSummarize(zoomPhoneResultId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getTranscriptionSummarization operation in TranscriptionSummarizationApi.
 * @export
 * @interface TranscriptionSummarizationApiGetTranscriptionSummarizationRequest
 */
export interface TranscriptionSummarizationApiGetTranscriptionSummarizationRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof TranscriptionSummarizationApiGetTranscriptionSummarization
     */
    readonly zoomPhoneResultId: number
}

/**
 * Request parameters for postTranscriptionSummarize operation in TranscriptionSummarizationApi.
 * @export
 * @interface TranscriptionSummarizationApiPostTranscriptionSummarizeRequest
 */
export interface TranscriptionSummarizationApiPostTranscriptionSummarizeRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof TranscriptionSummarizationApiPostTranscriptionSummarize
     */
    readonly zoomPhoneResultId: number
}

/**
 * TranscriptionSummarizationApi - object-oriented interface
 * @export
 * @class TranscriptionSummarizationApi
 * @extends {BaseAPI}
 */
export class TranscriptionSummarizationApi extends BaseAPI implements TranscriptionSummarizationApiInterface {
    /**
     * 文字起こし要約取得API
     * @summary 文字起こし要約取得API
     * @param {TranscriptionSummarizationApiGetTranscriptionSummarizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionSummarizationApi
     */
    public getTranscriptionSummarization(requestParameters: TranscriptionSummarizationApiGetTranscriptionSummarizationRequest, options?: AxiosRequestConfig) {
        return TranscriptionSummarizationApiFp(this.configuration).getTranscriptionSummarization(requestParameters.zoomPhoneResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 文字起こし要約生成API
     * @summary 文字起こし要約生成API
     * @param {TranscriptionSummarizationApiPostTranscriptionSummarizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionSummarizationApi
     */
    public postTranscriptionSummarize(requestParameters: TranscriptionSummarizationApiPostTranscriptionSummarizeRequest, options?: AxiosRequestConfig) {
        return TranscriptionSummarizationApiFp(this.configuration).postTranscriptionSummarize(requestParameters.zoomPhoneResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
